<h1 mat-dialog-title>{{rootTaskInProgress?.DisplayTitle}}
  <circle-progress
    [percent]="rootTaskInProgress?.Progress"
    [backgroundColor]="rootTaskInProgress ? getBackgroundColor(rootTaskInProgress) : '#ffffff'"
    [backgroundPadding]="rootTaskInProgress ? getBackgroundPadding(rootTaskInProgress) : 0"
    [titleFontSize]="rootTaskInProgress ? getTitleFontSize(rootTaskInProgress) : '10'"
    [radius]="20"
    [space]="-2"
    [outerStrokeWidth]="2"
    [outerStrokeColor]="'#808080'"
    [innerStrokeWidth]="2"
    [innerStrokeColor]="'#e7e8ea'"
    [showSubtitle]="false"
    [animation]="false"
  ></circle-progress>
</h1>
<div mat-dialog-content>
  <!-- Summary line -->
  <div class="download-summary" *ngIf="totalFileCount > 0">
    <span>{{successCount}} of {{totalFileCount}} files downloaded</span>
    <span class="failed-count" *ngIf="failedTasks.length > 0">, <strong>{{failedTasks.length}} failed</strong></span>
  </div>

  <!-- Failed-file expansion panel -->
  <mat-expansion-panel *ngIf="failedTasks.length > 0" class="failed-files-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>Failed Files ({{failedTasks.length}})</mat-panel-title>
    </mat-expansion-panel-header>
    <div *ngFor="let task of failedTasks" class="failed-file-row">
      <span class="failed-file-path" [matTooltip]="task.DisplayTitle">{{task.DisplayTitle}}</span>
      <span class="failed-file-error" *ngIf="task.ErrorReason"> — {{task.ErrorReason}}</span>
      <button mat-icon-button [disabled]="isRetrying" (click)="retryFile(task.Id)"
              matTooltip="Retry this file" aria-label="Retry file">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </mat-expansion-panel>

  <mat-form-field appearance="fill" style="width:100%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="enter filter text" [(ngModel)]="filterText" #input>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" aria-labelledby="task progress">

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef> Title </th>
      <td mat-cell *matCellDef="let task"> <a *ngIf="task.Data?.Url" target="_blank" href="{{task.Data?.Url}}">{{task.DisplayTitle}}</a> <span *ngIf="!task.Data?.Url">{{task.DisplayTitle}}</span> </td>
    </ng-container>

    <ng-container matColumnDef="progress">
      <th mat-header-cell *matHeaderCellDef> Progress </th>
      <td mat-cell *matCellDef="let task">
        <circle-progress
          [percent]="task.Progress"
          [backgroundColor]="getBackgroundColor(task)"
          [backgroundPadding]="getBackgroundPadding(task)"
          [titleFontSize]="getTitleFontSize(task)"
          [radius]="20"
          [space]="-2"
          [outerStrokeWidth]="2"
          [outerStrokeColor]="'#808080'"
          [innerStrokeWidth]="2"
          [innerStrokeColor]="'#e7e8ea'"
          [showSubtitle]="false"
          [animation]="false"
        ></circle-progress> </td>

    </ng-container>


    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let task">
        <span>{{task.Status}}</span>
        <span class="error-reason" *ngIf="task.ErrorReason"> — {{task.ErrorReason}}</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: false"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter "{{lastSearchedText}}"</td>
    </tr>
  </table>

</div>
<mat-dialog-actions align="end">
  <button mat-raised-button color="warn"
          [disabled]="!canRetry"
          (click)="retryFailedDownloads()"
          matTooltip="Re-download only the failed files">
    <mat-spinner *ngIf="isRetrying" diameter="18" style="display:inline-block;margin-right:6px"></mat-spinner>
    <span>{{isRetrying ? 'Retrying…' : 'Retry Failed Downloads'}}</span>
  </button>
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
